module.exports = __webpack_public_path__ + "img/MS.26edb007.svg";